export const handleQueryCellInfo = (args) => {
    if (args.column.cssClass === "subtract-column") {
        args.cell.style.color = "#C41E3A";
        args.cell.style.backgroundColor = "rgba(255, 0, 0, 0.04)";
    } else if (args.column.cssClass === "add-column") {
        args.cell.style.color = "#6bba77";
        args.cell.style.backgroundColor = "rgba(0, 128, 0, 0.04)";
    } else if (args.column.cssClass === "percentage-value") {
        args.cell.style.color = "#eeeeee";
    } else if (args.column.headerText === 'Driver Balance') {
        if (!isNaN(args.cell.innerText)) {
            const val = parseFloat(args.cell.innerText);
            if (val < 0) {
                args.cell.style.backgroundColor = "rgba(255, 0, 0, 0.1)";
            } else {
                args.cell.style.backgroundColor = "rgba(0, 128, 0, 0.1)";
            }
        } else {
            args.cell.style.backgroundColor = "";
        }
    } else if (args.column.headerText === 'Total Correction') {
        if (!isNaN(args.cell.innerText)) {
            const val = parseFloat(args.cell.innerText);
            if (val < 0) {
                args.cell.style.color = "#C41E3A";
            } else {
                args.cell.style.color = "#6bba77";
            }
        } else {
            args.cell.style.backgroundColor = "";
        }
    }
}